module.exports = __webpack_public_path__ + "img/win-large.b719c0be.webp";